var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 62,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M60 0 24 37.2 12 24.8 0 37.2 24 62l48-49.6z"
})));
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNjIiIHZpZXdCb3g9IjAgMCA3MiA2MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYwIDBMMjQgMzcuMkwxMiAyNC44TDAgMzcuMkwyNCA2Mkw3MiAxMi40TDYwIDBaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";